import styles from './AboutUsPage.module.scss';

// icons
import { Sparkles, HandHeart, GraduationCap } from 'lucide-react';

const AboutUsPage = () => {
  const boxesInfo = [
    {
      id: '1',
      title: 'Diagnoza i terapia psychologiczna dla dorosłych',
      description:
        'Świadczymy kompleksową pomoc w obszarze diagnozy i terapii osób dorosłych m.in. w związku z występieniem zaburzeń adaptacyjnych, lękowych, depresyjnych czy też innych głębszych zaburzeń psychicznych.',
      points: [
        'Konsultacje psychiatryczne',
        'Psychoterapia indywidualna',
        'Wsparcie w kryzysach psychicznych',
        'Diagnoza psychologiczna na potrzeby orzecznicze',
      ],
    },
    {
      id: '2',
      title: 'Pomoc dla dzieci, młodzieży i rodzin',
      description:
        'Wspieramy również rozwój i pomagamy pokonywać trudności dzieciom, młodzieży i ich rodzinom – począwszy od diagnozy przyczyn, a skończywszy na rzetelnie opracowanym planie terapeutycznym.',
      points: [
        'Konsultacje psychologiczne dla dzieci',
        'Terapia zaburzeń lękowych i nastroju',
        'Terapia integracji sensorycznej',
        'Konsultacje logopedyczne',
        'Konsultacje neurologopedyczne'
      ],
    },
    // {
    //   id: '3',
    //   title: 'Konsultacje logopedyczne / neurologopedyczne',
    //   description:
    //     'Zapewniamy diagnozę i terapię logopedyczną oraz neurologopedyczną dla dorosłych z trudnościami w mowie, artykulacji, komunikacji oraz po incydentach neurologicznych. Pracujemy holistycznie, dobierając metody do indywidualnych potrzeb, aby poprawa była skuteczna i zauważalna w codziennym funkcjonowaniu.',
    //   points: [
    //     'Terapia zaburzeń mowy i artykulacji',
    //     'Wsparcie po udarach i urazach neurologicznych',
    //     'Trudności w płynności i jakości głosu',
    //     'Konsultacje logopedyczne',
    //   ],
    // },
  ];

  const boxIcons = [
    {
      id: '1',
      icon: <Sparkles />,
      title: 'Najwyższe standardy',
      description:
        'Pracujemy w oparciu o najwyższe standardy regularnie superwizując własną pracę terapeutyczną i stale podnosząc kompetencje zawodowe',
    },
    {
      id: '2',
      icon: <HandHeart />,
      title: 'Empatia i partnerstwo',
      description:
        'Łączymy indywiduzalizm z empatycznym podejściem, które jest kluczowe w procesie zdrowienia i wspierania naszych klientów.',
    },
    {
      id: '3',
      icon: <GraduationCap />,
      title: 'Ciągły rozwój',
      description:
        'Systematycznie się szkolimy i uczestniczymy w superwizjach, aby zapewniać najwyższej jakości opiekę.',
    },
  ];
  return (
    <div className={styles.aboutUs}>
      <div>
        <h1 className={styles.title}> O nas </h1>
        <p className={styles.info}>
          Centrum Rozwoju i Terapii MOTUS s.c. Anna Paluch Jarosław Słoma
          oferuje specjalistyczne leczenie w ramach ambulatoryjnej opieki
          zdrowotnej.
        </p>
      </div>
      {/* two description*/}
      <div className={styles.boxInfo}>
        {boxesInfo.map((boxInfo) => (
          <div className={styles.box} key={boxInfo.id}>
            <h3 className={styles.titleInfo}>{boxInfo.title}</h3>
            <p className={styles.item}>{boxInfo.description}</p>
            <ul>
              {boxInfo.points.map((point, index) => (
                <li key={index}> {point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {/*box icons */}
      <div className={styles.boxIcons}>
        {boxIcons.map((boxIcon) => (
          <div className={styles.box} key={boxIcon.id}>
            <div className={styles.icons}>{boxIcon.icon}</div>
            <p>{boxIcon.title}</p>
            <p className={styles.description}>{boxIcon.description}</p>
          </div>
        ))}
      </div>

      {/* expiriens box*/}
      <div className={styles.boxExperience}>
        <div className={styles.box}>
          <h3>10 +</h3>
          <p>lat doświadczenia zespołu</p>
        </div>
        <div className={styles.box}>
          <h3>4</h3>
          <p>specjalizacje terapeutyczne</p>
        </div>
        <div className={styles.box}>
          <h3>1000 +</h3>
          <p>zrealizowanych spotkań</p>
        </div>
      </div>

      <div className={styles.boxSpecial}>
        <h1>Etyka zawodowa i dyskrecja </h1>
        <p>
          W naszej pracy kierujemy się zasadami etyki zawodowej (Kodeks etyczny
          psychologa) i jesteśmy zobowiązani do przestrzegania tajemnicy
          zawodowej. Każdy klient może liczyć na pełne zrozumienie, dyskrecję
          oraz skuteczną pomoc w pokonywaniu trudności emocjonalnych.
        </p>
        <div className={styles.item}>
          <p>
            Nasze Centrum to miejsce, gdzie każdy klient może liczyć na
            empatyczne podejście i profesjonalną opiekę zdrowotną.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
